var _event = 'OPEN_ORDERPAY';

function customUserEvent(orderSn, opts) {
  var event = new Event(_event);
  event.orderSn = orderSn;
  event.opts = opts;
  window.dispatchEvent(event);
}
/**
 * 自定义用户事件，用来处理订单相关操作
 * @function
 * @param {string} - 订单编号
 * @param {OpenOrderPayOpts} - 额外处理操作，包括：成功/失败回调
 * @example
 * openOrderPay(data, { onPaySuccess: onSuccess });
 */


export var openOrderPay = function openOrderPay(orderSn, opts) {
  customUserEvent(orderSn, opts);
};
/**
 * 自定义用户事件，用来处理订单相关操作
 * @function
 * @param {string} - 订单编号
 * @param {OpenOrderPayOpts} - 额外处理操作，包括：成功/失败回调
 * @example
 * openOrderPay(data, { onPaySuccess: onSuccess });
 */

export var addOpenOrderPayEventListener = function addOpenOrderPayEventListener(eventFn) {
  function _eventFn(e) {
    window.setTimeout(function () {
      eventFn(e.orderSn, e.opts, e);
    });
  } //当前tab页有效


  window.addEventListener(_event, _eventFn);
  return function () {
    window.removeEventListener(_event, _eventFn);
  };
};